import React from "@platform/react";
import { Component } from "@platform/react-storybook/Component";
import { Carousel } from "@platform/react-storybook/Component/Carousel";
import { VectorAsset } from "@front/components/Element/Asset/Vector";

import Rules from "./_rules.module.scss";
import type { PropTypesSponsor } from "./types";
import { DEF_SPONSOR, NAME_SPONSOR, TYPE_SPONSOR } from "./types";

export function SponsorSection(props: PropTypesSponsor) {
    const { items, ...rest } = props;
    return (
        <Component {...rest} name={NAME_SPONSOR} tag="div" type={TYPE_SPONSOR}>
            <Carousel className={Rules.sponsor} direction="ltr" duration={90}>
                {items.map(({ uuid, logo }) => (
                    <VectorAsset key={uuid} caption="" fill="bolivia" uuid={logo} />
                ))}
            </Carousel>
        </Component>
    );
}
SponsorSection.defaultProps = DEF_SPONSOR;
